import { z } from 'zod';
import { FERTILIZER_PACK_SLOTS } from '../constants/maintenance.constants';

const slotValue = z.string();

export const FertilizerPackSchema = z
	.object({
		name: z.string().trim().min(2, 'A identificação deve ter ao menos 2 caracteres.'),
		mix: slotValue,
		N: slotValue,
		P2O5: slotValue,
		K2O: slotValue,
		Ca: slotValue,
		Mg: slotValue,
		S: slotValue,
		B: slotValue,
		Zn: slotValue,
		Cu: slotValue,
		Mn: slotValue,
		Fe: slotValue,
	})
	.superRefine((data, ctx) => {
		const ids = FERTILIZER_PACK_SLOTS.map(({ key }) => data[key]).filter(Boolean);
		if (new Set(ids).size < 2) {
			ctx.addIssue({
				code: 'custom',
				path: ['name'],
				message: 'Selecione ao menos dois fertilizantes diferentes.',
			});
		}
	});

export type FertilizerPackSchemaType = z.infer<typeof FertilizerPackSchema>;
